"use client"

import { pageview } from "@/utils/gtm"
import { GoogleTagManager } from "@next/third-parties/google"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

type Props = {
  companyName: string
  locale: string
  subcompany?: string
  projectType?: string
}

const gtmId = process.env.GTM_ID || "GTM-WHHF8NWQ"

export default function Analytics({}: Props) {
  const pathname = usePathname()

  if (!gtmId) {
    return null
  }

  useEffect(() => {
    pageview()
    // Dispatch route-change-callbox event whenever pathname changes
    const event = new CustomEvent("route-change-callbox", {
      detail: {
        pathname,
        timestamp: new Date().getTime(),
      },
    })
    window?.dispatchEvent?.(event) // <-- dispatch on window
    // trigger dom event pathChange without any data
    window?.dispatchEvent?.(new Event("pathChange"))
  }, [pathname])

  return <GoogleTagManager gtmId={gtmId} />
}
